import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { AreaAdditionItemEdit } from "./area-addition.item.edit";
import {
  emptyAreaAddition,
  IAreaAdditionItemForm,
} from "./area-addition.models";

export const AreaAdditionItemAdd: FC<IAreaAdditionItemForm> = ({
  index,
  setValue,
  getValues,
  fieldName,
  onEditStart,
  onEditEnd,
}) => {
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      {isAddNewOpened && (
        <AreaAdditionItemEdit
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          value={emptyAreaAddition}
          index={index}
          onCancel={() => {
            setAddNewOpenedState(false);
          }}
          isNew
        />
      )}
      {!isAddNewOpened && (
        <div className="add_item_button_wrapper">
          <Button type="button" onClick={() => setAddNewOpenedState(true)}>
            {t("general.APPEND")}
          </Button>
        </div>
      )}
    </>
  );
};
